import * as React from 'react'

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

const getInitialPreference = (): boolean => {
  if (typeof window === 'undefined' || !window.matchMedia) { return false }
  return window.matchMedia(REDUCED_MOTION_QUERY).matches
}

/**
 * Returns whether the user has requested reduced motion via their OS settings.
 * The value updates live when the preference changes.
 */
const usePrefersReducedMotion = (): boolean => {
  const [prefersReducedMotion, setPrefersReducedMotion] = React.useState<boolean>(getInitialPreference)

  React.useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) { return }

    const mediaQuery = window.matchMedia(REDUCED_MOTION_QUERY)
    const handleChange = (event: MediaQueryListEvent) => {
      setPrefersReducedMotion(event.matches)
    }

    // Sync state with the current value in case it changed between initial
    // render and effect commit.
    setPrefersReducedMotion(mediaQuery.matches)

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return prefersReducedMotion
}

export default usePrefersReducedMotion
